import { type FC } from "react";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { Card } from "@jti/core-components/components/Card";
import { Loader } from "@jti/core-components/components/Loader";
import { Controller, useFormContext, useTranslations } from "@jti/ui";

import { DeliveryOptionsList } from "./components/DeliveryOption";

import type { DeliveryOptionsFieldConfig } from "./DeliveryOptionsFieldV2.types";

export type DeliveryOptionsFieldV2Props = {
  fieldConfig: DeliveryOptionsFieldConfig;
};

export const DeliveryOptionsFieldV2: FC<DeliveryOptionsFieldV2Props> = ({ fieldConfig }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { __ } = useTranslations();

  const { name, options, isSubscription, onChange, registerOptions, isLoading } = fieldConfig;
  const fieldError = errors[name];

  const hasNoOptions = options.length === 0;

  return (
    <div data-testid="delivery-options-card">
      <Card title={__("cart.checkout.shipping_options.title")}>
        {isLoading ? (
          <Loader />
        ) : hasNoOptions ? (
          <AlertBanner tone="info" description={__("cart.checkout.shipping_options.no_options")} />
        ) : (
          <Controller
            control={control}
            name={name}
            rules={registerOptions}
            render={({ field }) => (
              <DeliveryOptionsList
                {...field}
                options={options}
                isSubscription={isSubscription}
                error={!!fieldError}
                errorText={fieldError?.message as string | undefined}
                onChange={(e) => {
                  const deliveryOption = e.target.value;
                  field.onChange(deliveryOption);
                  onChange?.(deliveryOption);
                }}
              />
            )}
          />
        )}
      </Card>
    </div>
  );
};
